export function dropZoneTransition(dropZoneRef, dragOver, dragOverClassName) {
  if (dropZoneRef && dropZoneRef.current) {
    if (dragOver) {
      dropZoneRef.current.classList.add(dragOverClassName);
    } else {
      dropZoneRef.current.classList.remove(dragOverClassName);
    }
  }
}
